import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { queryOptions } from '../use-hydra';
import {
  getPreviewProject,
  getPreviewProjectsDashboard,
} from '../../api/preview';
import { AnswerState } from '../../hydra';
import useAuth from '../use-auth';
import queryString from 'query-string';

export function usePreviewProject(projectSlug: string) {
  const { getTokenSilently, isAuthenticated } = useAuth();
  const query = useLocation();

  const state = useQuery(
    ['get-preview-project', isAuthenticated, projectSlug],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      const appliedProject = await getPreviewProject(token, {
        projectSlug,
      });

      let answerStates: Record<string, AnswerState> = {};
      try {
        const parsed = queryString.parse(query.search);

        // Parse stringifiedAnswerStates from query params
        const stringifiedAnswerStates =
          parsed.stringifiedAnswerStates as string;

        if (stringifiedAnswerStates) {
          answerStates = JSON.parse(stringifiedAnswerStates);
        }
      } catch (err) {
        console.error('cannot parse answerStates query');
      }

      return {
        ...appliedProject,
        latest_submission: {
          id: 999,
          updated_at: new Date().toString(),
          created_at: new Date().toString(),
          difficulty_rating: null,
          feedback: null,
          seconds_spent: null,
          activity_session_id: 999,
          ai_review: null,
          answer_states: answerStates,
          mentor_reviews: [],
        },
      };
    },
    queryOptions
  );
  return {
    value: state.data,
    loading: state.isLoading,
    error: state.error,
    retry: state.refetch,
  };
}

export function usePreviewProjectsDashboard() {
  const { getTokenSilently, isAuthenticated } = useAuth();
  const state = useQuery(
    ['get-preview-projects-dashboard', isAuthenticated],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      const projects = await getPreviewProjectsDashboard(token);
      return projects;
    },
    queryOptions
  );
  return {
    value: state.data,
    loading: state.isLoading,
    error: state.error,
    retry: state.refetch,
  };
}
